<template>
<div class="countdownCard">
  <div class="countdownCard-timer">
    <div class="countdownCard-timer_title"><span></span>剩余时间</div>
    <div class="countdownCard-timer_time" :class="{deadline: isDeadline}">{{countdownTime}}</div>
  </div>
  <div class="countdownCard-progress">
    <div class="countdownCard-progress_bar">
      <div class="countdownCard-progress_bar-fill" :style="{width: questionData.percent}">
      </div>
    </div>
    <div class="countdownCard-progress_info">
      <div>已完成{{questionData.finished}}题</div>
      <div>共{{questionData.total}}题</div>
    </div>
  </div>
</div>
</template>

<script>
import { getSystemTime } from '@/api/api';

export default {
  name: 'ExamCountdownCard',
  props: {
    endTime: {
      type: Number,
      default: 0,
    },
    answerList: {
      type: Array,
      default: () => [],
    }
  },
  data(){
    return {
      countdownTime: '00:00:00',
      isDeadline: false,
    };
  },
  computed: {
    questionData() {
      const finished = this.answerList.filter(item => {
        const answer = item.submitPayload;
        return answer?.submitOption?.length > 0 || answer?.pics?.length > 0;
      }).length;
      const total = this.answerList.length;
      return {
        finished,
        total,
        percent: `${finished / total * 100}%`,
      }
    }
  },
  created() {
    this.startCountdown();
  },
  methods: {
    async startCountdown() {
      const endTime = this.endTime;
      const now = await getSystemTime();
      const distance = endTime - now;
      if (distance <= 0) {
        this.distance = '00:00:00';
        this.$emit('timeout');
        return;
      }
      const hours = Math.floor(distance / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);
      this.countdownTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      if ((distance / 1000) <= 180) {
        this.isDeadline = true;
      }
      setTimeout(() => {
        this.startCountdown();
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.countdownCard {
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  border-radius: 20px;
  padding: 24px 20px;
  &-timer {
    background: #F5F6F9;
    border-radius: 12px;
    height: 78px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    &_title {
      display: flex;
      align-items: center;
      color: #86909C;
      font-size: 14px;
      margin-bottom: 8px;
      span {
        width: 14px;
        height: 14px;
        margin-right: 4px;
        background: url('@/common/images/student/ic_clock.png') no-repeat center / contain;
      }
    }
    &_time {
      color: #000000E5;
      font-size: 20px;
      font-weight: 600;
       &.deadline{
        color: #FF6047;
      }
    }
  }
  &-progress {
    &_bar {
      width: 100%;
      height: 6px;
      background: #F5F6F9;
      border-radius: 90px;
      margin-bottom: 8px;
      &-fill {
        background: linear-gradient(93.31deg, #FF7E7E 4.1%, #E60012 98.63%);
        height: 100%;
        border-radius: 90px;
      }
    }
    &_info {
      display: flex;
      justify-content: space-between;
      color: #86909C;
      font-size: 12px;
    }
  }
}
</style>
